import { getEventPartner } from './get-event-partner.function'
import { FloEvent } from '@flocasts/flosports30-types/dist/entity'

export const checkEventPartnerMatchesDrillThrough = (event: Pick<FloEvent, 'drill_through_link' | 'node'>) => {
  const partner = getEventPartner(event)
  const partnerUrl = partner && partner.slug_uri
  const drillthrough = event.drill_through_link
  const drillthroughUrl = drillthrough && drillthrough.slug_uri
  return partnerUrl === drillthroughUrl
}
